import Repository from './Repository';

const resource = '/perfis-preferencia';

export default {
  get() {
    return Repository.get(`${resource}`);
  },
  save(preferencia) {
    return Repository.put(`${resource}`, preferencia);
  },
};
